import React from 'react';
import { RadioButton } from 'primereact/radiobutton';
import styles from './Radio.module.scss';

export default function Radio({
    name,
    formik,
    value,
    label,
    rowReverse = false,
    className = '',
    ...rest
}) {
    return (
        <div
            className={`${!rowReverse ? styles.containerReverse : styles.container} ${
                className ?? ''
            }`}
        >
            <div className={styles.label}>{label}</div>
            <div className={styles.radioContainer}>
                <RadioButton
                    name={name}
                    onChange={(ev) => {
                        if (formik) formik.setFieldValue(name, ev.value);
                    }}
                    value={value}
                    checked={formik ? `${formik.values[name]}`.trim() === `${value}`.trim() : false}
                    {...rest}
                />
            </div>
        </div>
    );
}
